<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Cx2R4H/tc-custom/9781680570175.jpg?1740299474342" alt="This image is the cover for the book Brother Blood Sister Death"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Brother Blood Sister Death
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A modern, nonviolent vampire fears his twin sister’s traditional, gruesome habits will expose them in this dark thriller.</b></p><p> Hybrid vampires Daniel and Diana feel technology’s cold, uncountable tendrils hunting them. Daniel scientifically satisfies his needs. Diana, his twin sister, hunts in the old-school way, leaving patches of greasy, scorched earth or mutilated bodies for her brother to take care of. </p><p> Daniel created Matrix, a face pack for beauty shops, which pulls blood through skin, leaves blissful clients, kills and alerts no one. He prefers milking to butchering. Daniel cultivates his human side; Diana mocks him. Impatient, she hunts out of spite as much as need. </p><p> Daniel finally understands that his twin sister will get him killed, and his life’s hardest decision is at hand: To milk? Or to butcher? </p><p><b>Praise for <i>Brother Blood Sister Death</i></b></p><p><b>“A novel of vampire seduction, murder intrigue, and blood. Accomplished poet and novelist Bill Ransom uses humor in especially delicious ways.” —Brian Herbert, <i>New York Times</i>–bestselling coauthor of <i>Dune: House Atreides</i></b></p><p><b>“A classic vampire novel rife with secrets…but it’s no secret that I loved it! Complicated relationships and unexpected twists and turns mix with good old-fashioned vampire violence for a great read. More, Bill Ransom!” —Nancy Holder, <i>New York Times</i>–bestselling author of The Wicked Saga</b></p><b>“A highly entertaining, riveting story about twin adult vampires. . . . Couldn’t put this one down—definitely worth a bite.” —Anna Quin, author of <i>The Night Child</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bill Ransom
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WordFire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?10beb0b4